import React from "react";
import Typography from "../../../../../../components/Typography/Typography";
import TextField from "../../../../../../components/forms/TextField";
import TextArea from "../../../../../../components/forms/TextArea";

const SustainabilityInfoSection = () => {
    return (
        <div className="mb-4">
            <Typography variant="h5" className="mb-3">
                Sustainability Information
            </Typography>
            <div className="mb-3">
                <TextField
                    name="sustainability_title"
                    label="Sustainability Title"
                />
            </div>
            <div className="mb-3">
                <TextArea
                    name="sustainability_description"
                    label="Sustainability Description"
                    rows={4}
                />
            </div>

            <Typography variant="h6" className="mb-3">
                External Button
            </Typography>
            <div className="mb-3">
                <TextField
                    name="external_button.button_text"
                    label="Button Text"
                    placeholder="Enter button text"
                />
            </div>
            <div className="mb-3">
                <TextField
                    name="external_button.button_link"
                    label="Button Link"
                    placeholder="Enter URL (e.g., https://example.com)"
                />
            </div>
        </div>
    );
};

export default SustainabilityInfoSection;
